/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGADynamicEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

type MapTabKey = 'destinations' | 'themes';

/**
 * experiential-stay LP の GA4 クリック計測。
 * LP 配下に閉じるため、型登録が要らない sendWabunkaGADynamicEvent を薄くラップする。
 * イベント名と param 整形（tab のキー名寄せ等）はこの1箇所に集約する。
 */
export const useLpTracking = () => {
  // ヒーローの「Request an itinerary」
  const trackHeroCta = () => sendWabunkaGADynamicEvent('hero_cta_click', { section: 'hero' });

  // ページ下部 CTA
  const trackItineraryCta = () => sendWabunkaGADynamicEvent('itinerary_cta_click', { section: 'bottom' });

  // マップの Destinations / Curated Themes タブ切替。DOM 上のキー themes を計測名 curated_themes に寄せる。
  const trackTab = (key: MapTabKey) => sendWabunkaGADynamicEvent('tab_click', { tab_name: key === 'themes' ? 'curated_themes' : 'destinations' });

  // Destinations タブのエリア選択（SP カード / PC マップ領域の両経路）
  const trackDestination = (areaName: string) => sendWabunkaGADynamicEvent('destination_click', { area_name: areaName });

  // Curated Themes タブの各テーマカード
  const trackTheme = (themeName: string) => sendWabunkaGADynamicEvent('theme_click', { theme_name: themeName });

  // The Spirit of Place の各記事カード
  const trackArticle = (articleTitle: string) => sendWabunkaGADynamicEvent('article_click', { article_title: articleTitle });

  // Wabunka Story の人物カード
  const trackStory = (storyTitle: string) => sendWabunkaGADynamicEvent('story_click', { story_title: storyTitle });

  // Gallery の View More
  const trackGalleryViewMore = () => sendWabunkaGADynamicEvent('gallery_view_more_click');

  return {
    trackHeroCta,
    trackItineraryCta,
    trackTab,
    trackDestination,
    trackTheme,
    trackArticle,
    trackStory,
    trackGalleryViewMore,
  };
};
